// CONSTANTS
export const TEMPLATE_DETAILS_PATH = '/:section/:id/details';

export const TEMPLATE_DETAILS_JURISDICTION_PATH =
  '/:section/:jurisdictionName/:state/details';

// PATTERNS
export const BROWSE_PATTERN = '/(.*)/browse';
